module.exports = __webpack_public_path__ + "static/media/post_feed.6580d593.svg";